import React, { useEffect, useState } from "react";
import dressstyleStyles from "./DressStyle.module.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";
import axios from "axios";

const cardStyles = [
  "dressstylecard1",
  "dressstylecard2",
  "dressstylecard3",
  "dressstylecard4",
];

const DressStyle = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get("http://localhost:5000/api/category/getCategories")
      .then((res) => {
        console.log(res.data);
        setCategories(res.data.categories || res.data);
      })
      .catch((err) => console.error("Failed to fetch categories:", err));
  }, []);
  console.log("=========================");
  console.log(categories);

  return (
    <section className={dressstyleStyles.dressstylecontainer}>
      <Container fluid className="p-lg-5 p-md-5">
        <div className="text-center mb-5 pt-lg-3 pt-5">
          <h2 className={`${dressstyleStyles.dressstyletitle} text-uppercase`}>
            BROWSE BY CATEGORY
          </h2>
        </div>
        <Row>
          {categories.slice(0, 4).map((category, index) => (
            <Col
              key={category._id}
              lg={index % 2 === 0 ? 5 : 7}
              md={index % 2 === 0 ? 5 : 7}
              className="mb-3"
            >
              <Link to="/shop" className="text-decoration-none">
                <Card
                  className={dressstyleStyles[`dressstylecard${index + 1}`]}
                >
                  <Card.Body>
                    <Card.Title
                      className={`${
                        dressstyleStyles[`dressstylecard${index + 1}`]
                      } ${dressstyleStyles.shrinkCard}`}
                    >
                      <h2>{category.Name}</h2>
                    </Card.Title>
                  </Card.Body>
                </Card>
              </Link>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default DressStyle;
